<template>
  <div id="gpa-app">
    <Gpa/>
  </div>
</template>

<script>
  import Gpa from './components/Gpa'
  export default {
    name: 'App',
    components: {
      Gpa
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "~@/scss/_base.scss";

  #app {
    width: 100%;
    min-width: 1200px;
    background-color: #6290F8;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue